import { isClient } from '@/utils/isClient';

export function isServer() {
  return !isClient();
}
